import api from './api';

export const categoryService = {
  // Get all categories (admin view)
  getAllCategories: async (params = {}) => {
    const response = await api.get('/admin/categories', { params });
    return response.data.data;
  },

  // Get category by ID
  getCategoryById: async (categoryId) => {
    const response = await api.get(`/admin/categories/${categoryId}`);
    return response.data.data.category;
  },

  // Create category (supports both FormData and regular JSON)
  createCategory: async (categoryData) => {
    // Check if it's FormData (for file uploads)
    const isFormData = categoryData instanceof FormData;
    
    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.post('/admin/categories', categoryData, config);
    return response.data.data;
  },

  // Update category (supports both FormData and regular JSON)
  updateCategory: async (categoryId, categoryData) => {
    // Check if it's FormData (for file uploads)
    const isFormData = categoryData instanceof FormData;
    
    const config = {
      headers: isFormData
        ? {
            // Don't set Content-Type for FormData - let browser set it with boundary
          }
        : {
            'Content-Type': 'application/json',
          },
    };

    const response = await api.put(`/admin/categories/${categoryId}`, categoryData, config);
    return response.data.data;
  },

  // Delete category
  deleteCategory: async (categoryId) => {
    const response = await api.delete(`/admin/categories/${categoryId}`);
    return response.data;
  },
};
